class RabobankConnectController extends AbstractIntegrationController
	@register()

	integrationId: 'rabobank'
